import { classes } from '../constants';
import { setActive } from './helpers';
import scrollTo from '../utils/scrollto';

export class Filters {
  constructor() {
    this.links = document.querySelectorAll('[data-js-filter]');
    this.select = document.querySelectorAll('[data-js-filter-select]');
    this.setAnchoredFilter();
    this.addEventListeners();
  }
  addEventListeners() {
    [...this.links].forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        this._filter(e.currentTarget);
      });
    });

    [...this.select].forEach(el => {
      el.addEventListener('change', e => {
        this._setActiveTarget(e.target.value);
        this._resetOtherFilters(e.target);
      });
    });

    if (this.onDOMLoaded) {
      window.addEventListener('DOMContentLoaded', this.onDOMLoaded);
    }
  }
  setAnchoredFilter() {
    const hash = window.location.hash.substr(1);
    if (!hash) {
      return false;
    }

    [...this.links].forEach(el => {
      if (el.getAttribute('data-js-filter') === hash) {
        this._filter(el);
        this.onDOMLoaded = () => {
          if (el.offsetParent !== null) {
            scrollTo(el);
          } else {
            let selectedElement;
            [...this.select].forEach(el => {
              const optionEl = el.querySelector('[value="' + hash + '"]');
              if (optionEl) {
                optionEl.selected = true;
                selectedElement = el;
              }
            });
            scrollTo(selectedElement);
          }
        };
        return true;
      }
    });

    return true;
  }
  _filter(el) {
    const target = el.getAttribute('data-js-filter');

    setActive(this.links, el);
    this._setActiveTarget(target);
  }
  _setActiveTarget(target, checkNoResults = true) {
    const targets = document.querySelectorAll(`.filter-${target}`);
    const all = document.querySelectorAll('[data-js-filter-item]');

    [...all].forEach(item => item.parentNode.classList.remove(classes.active));
    [...targets].forEach(item => item.parentNode.classList.add(classes.active));

    if (checkNoResults && targets.length === 0) {
      this._setNoResults();
    }
  }
  _resetOtherFilters(currentFilter) {
    [...this.select].forEach(el => {
      if (el !== currentFilter) {
        el.querySelectorAll('option').forEach(option => {
          option.selected = false;
        });
        el.firstChild.selected = true;
      }
    });
  }
  _setNoResults() {
    this._setActiveTarget('no-results', false);
  }
}

if (document.querySelectorAll('[data-js-filter]').length) {
  const filters = new Filters();
}
